import React, { FC } from 'react';
import { Icon } from '@adsk/alloy-react-icon';

const TradeTappColorfulIcon: FC = () => {
  return (
    <Icon size={24} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6497 2.97656C17.4264 2.97656 19.0989 3.65617 20.3587 4.89252C21.6196 6.12888 22.3132 7.7678 22.3125 9.51015V13.9884C22.3125 14.6275 21.7843 15.1463 21.1334 15.1463H19.9884C19.3366 15.1463 18.8093 14.6275 18.8093 13.9884V13.1867H14.8305C14.1789 13.1867 13.6507 12.6705 13.6507 12.0312V10.9082C13.6507 10.2692 14.1789 9.75198 14.8305 9.75198H18.8093V9.51088C18.8093 7.80203 17.3926 6.41174 15.6497 6.41174H8.95658C8.30476 6.41174 7.77653 5.89481 7.77653 5.25576V4.13206C7.77653 3.49446 8.30476 2.97656 8.95658 2.97656H15.6497ZM8.35025 16.5264H15.0427C15.6945 16.5264 16.2218 17.0426 16.2218 17.6827V18.8056C16.2218 19.444 15.6945 19.9619 15.0427 19.9619H8.35025C6.57264 19.9619 4.90039 19.2813 3.63956 18.0449C2.38044 16.8103 1.68677 15.1704 1.6875 13.4273V8.94928C1.6875 8.31168 2.21475 7.79329 2.86657 7.79329H4.01085C4.66267 7.79329 5.18992 8.31168 5.18992 8.94928V9.75198H9.16923C9.82032 9.75198 10.3485 10.2689 10.3485 10.908V12.0309C10.3485 12.6702 9.82032 13.1864 9.16923 13.1864H5.18992V13.4273C5.18992 15.1364 6.60744 16.5264 8.35025 16.5264Z"
        fill="#5B747C"
      />
    </Icon>
  );
};

export default TradeTappColorfulIcon;
